/**
 * Typography Configuration
 * Custom font sizes for cases where MUI variants are not suitable
 */

// Font sizes (px strings)
export const TYPO_LABEL_XS = '9px'; // Мелкие labels (LANGUAGE)
export const TYPO_LABEL_SM = '11px'; // Captions (screen type, ID)
export const TYPO_BODY = '14px'; // Стандартный body text
export const TYPO_TITLE = '16px'; // Заголовки секций

// Letter spacing
export const TYPO_LETTER_SPACING_LABEL = '0.5px';
